import { Route } from "@angular/router";

export const FederationPaths = {
  Overview: (departmentGroupId: number | string) => `afdeling/${departmentGroupId}/organisaties`,
  TeamList: (departmentGroupId: number | string) => `afdeling/${departmentGroupId}/ledengroepen`,
  OrganizationEdit: (organizationId: number | string) => `organisatie/${organizationId}`,
  FormDocumentStatusList: (departmentGroupId: number | string, formId: number | string) =>
    `afdeling/${departmentGroupId}/formulier/${formId}/dossiers`,
  Import: "afdeling/importeren",
  Departments: "afdelingen",
  DepartmentAdd: "afdelingen/toevoegen",
  DepartmentEdit: (id: number | string) => `afdelingen/${id}/bewerken`,
};

export default [
  {
    path: FederationPaths.Departments,
    loadComponent: () =>
      import("./pages/department-list/department-list.component").then(
        (c) => c.DepartmentListComponent
      ),
    data: {
      breadcrumb: "Afdelingen",
      title: "Afdelingen",
    },
  },
  {
    path: FederationPaths.DepartmentAdd,
    loadComponent: () =>
      import("./pages/department-edit/department-edit.component").then(
        (c) => c.DepartmentEditComponent
      ),
    data: {
      breadcrumb: "Afdeling toevoegen",
      title: "Afdeling toevoegen",
    },
  },
  {
    path: FederationPaths.DepartmentEdit(":id"),
    loadComponent: () =>
      import("./pages/department-edit/department-edit.component").then(
        (c) => c.DepartmentEditComponent
      ),
    data: {
      breadcrumb: "Afdeling bewerken",
      title: "Afdeling bewerken",
    },
  },
  {
    path: FederationPaths.Overview(":id"),
    loadComponent: () =>
      import("./pages/federation-organisation-list/federation-organisation-list.component").then(
        (c) => c.FederationOrganisationListComponent
      ),
    data: {
      breadcrumb: "Verenigingen",
      title: "Verenigingen",
    },
  },
  {
    path: FederationPaths.TeamList(":id"),
    loadComponent: () =>
      import("./pages/federation-team-list/federation-team-list.component").then(
        (c) => c.FederationTeamListComponent
      ),
    data: {
      breadcrumb: "Ledengroepen",
      title: "Ledengroepen",
    },
  },
  {
    path: FederationPaths.OrganizationEdit(":id"),
    loadComponent: () =>
      import("../organisation/pages/organization-edit/organization-edit.component").then(
        (c) => c.OrganizationEditComponent
      ),
    data: {
      breadcrumb: "Organisatie aanpassen",
      title: "Organisatie aanpassen",
    },
  },
  {
    path: FederationPaths.FormDocumentStatusList(":departmentGroupId", ":formId"),
    loadComponent: () =>
      import("./pages/form-document-status-list/form-document-status-list.component").then(
        (c) => c.FormDocumentStatusListComponent
      ),
    data: {
      breadcrumb: "Dossiers",
      title: "Dossiers",
    },
  },
  {
    path: FederationPaths.Import,
    loadComponent: () =>
      import("./pages/organization-import/organization-import.component").then(
        (c) => c.OrganizationImportComponent
      ),
    data: {
      breadcrumb: "Organisaties importeren",
      title: "Organisaties importeren",
    },
  },
] satisfies Route[];
